import { getDownloadURL, ref } from 'firebase/storage';
import { InMemoryCache } from '@react-apps/core';
import { storage } from './firebase';

// O mesmo path de imagem (ex.: "images/questions/x_body.png") se repete em
// várias questões/páginas — cacheia a URL resolvida em memória pra não
// refazer o round-trip ao Storage a cada re-render/paginação.
const urlCache = new InMemoryCache<string>({ defaultTtl: 30 * 60 * 1000 });

// Resolve um path do Firebase Storage (não uma URL) pra uma URL pública de
// download. Conteúdo em markdown (body/comentário de questão) referencia
// imagens por path relativo ao bucket, não por URL absoluta.
export async function resolveStorageUrl(path: string): Promise<string> {
  const cached = urlCache.get(path);
  if (cached) return cached;

  const url = await getDownloadURL(ref(storage, path));
  urlCache.set(path, url);
  return url;
}
